<script>
  export let title;
  export let datePublished;
  export let dateModified;
  export let img;
  export let author;
  export let slug;

  let jsonld = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": `${title}`,
    "image": [
      `${img}`
    ],
    "datePublished": `${datePublished}`,
    "dateModified": `${dateModified}`,
    "author": [{
      "@type": "Person",
      "name": `${author}`,
    }],
    "publisher":{
      "name": "Crypto Market Cap",
      "url": "https://cryptomarketcap.com"
    },
  });

  let jsonld2 = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": `${title}`,
    "speakable": {
      "@type": "SpeakableSpecification",
      "xPath": [
        "/html/head/title",
        "/html/head/meta[@name='description']/@content"
      ]
    },
    "url": `https://cryptomarketcap.com/learn/${slug}`
  })

  let jsonldScript = `<script type="application/ld+json">${jsonld +"<"}/script><script type="application/ld+json">${jsonld2 +"<"}/script>`;
</script>

<svelte:head>
	{@html jsonldScript}
</svelte:head>